import {Component, Input, OnInit} from '@angular/core';
import {ErrorService} from '@app/services';
import {AboutSearchParams} from '../about-search-params';
import {AboutService} from '../about.service';
@Component({
  selector: 'hpf-about-count',
  templateUrl: './about-count.component.html'
})
export class AboutCountComponent implements OnInit {
  /** The filters */
  @Input() searchParams: AboutSearchParams = new AboutSearchParams();
  /** Count result */
  count: number;
  /** Load flag */
  loaded = false;
  /** Constructor */
  constructor(private aboutService: AboutService,
              private errorService: ErrorService) {}
  /** Init */
  ngOnInit() {
    this.aboutService.count(this.searchParams.toObject())
    .then((count) => {
      this.count = count;
      this.loaded = true;
    })
    .catch((error) => this.errorService.handle(error))
  }
}
